import { Currency } from '../types/Currency';

export const formatCurrency = (
  amount: string,
  currency: Currency,
  decimalPlace?: number,
  isBase: boolean = false
): string => {
  if (!amount || isNaN(Number(amount))) {
    amount = '0';
  }

  const value = parseFloat(amount) * parseFloat(isBase ? '1' : currency.value);
  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: currency.code,
    minimumFractionDigits: decimalPlace ?? currency.decimalPlace,
  };
  return new Intl.NumberFormat('en-US', options).format(value);
};

export const convertCurrency = (
  amount: string,
  currency: Currency,
  isBase: boolean = false
): number => {
  if (!amount || isNaN(Number(amount))) {
    return 0;
  }

  return parseFloat(amount) * (isBase ? 1 : parseFloat(currency.value));
};

export const formatNumber = (
  amount: string,
  currency: Currency,
  decimalPlace?: number
): string => {
  if (!amount || isNaN(Number(amount))) {
    return '';
  }

  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits: decimalPlace ?? currency.decimalPlace,
    maximumFractionDigits: decimalPlace ?? currency.decimalPlace,
  };
  return new Intl.NumberFormat(undefined, options).format(parseFloat(amount));
};

export const limitDecimals = (amount: string, decimals: number): string => {
  if (amount.includes('.') && amount.split('.')[1].length > decimals) {
    return `${amount.split('.')[0]}.${amount
      .split('.')[1]
      .substring(0, decimals)}`;
  }
  return amount;
};
